export default function SocialLinks() {
 return (
  <div className="d-flex justify-content-center">
   <a className="font-sm icon-circle-btn px-2" target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/equitrack/?viewAsMember=true">
    <i className="ai-linkedin"></i>
   </a>
   <a className="icon-circle-btn px-2" target="_blank" rel="noreferrer" href="https://www.facebook.com/dev4.online/">
    <i className="ai-facebook"></i>
   </a>
   <a className="icon-circle-btn px-2" target="_blank" rel="noreferrer" href="https://www.youtube.com/watch?v=nCrQhHcSwjc">
    <i className="ai-youtube"></i>
   </a>
  </div>
 )
}